const placeholderLocales = {
    en: 'Select Date',
    'zh-hant': '選擇日期',
    'zh-cn': '选择日期',
    vi: 'Chọn ngày',
    th: 'เลือกวันที่',
};
const placeholdersLocales = {
    en: ['Date From', 'To'],
    'zh-hant': ['日期從', '到'],
    'zh-cn': ['日期从', '到'],
    vi: ['Từ ngày', 'Tới ngày'],
    th: ['วันที่จาก', 'ถึง'],
};
const inputTooltipLocales = {
    en: 'Enter Format {{format}}',
    'zh-hant': '輸入格式 {{format}}',
    'zh-cn': '输入格式 {{format}}',
    vi: 'Nhập vào định dạng {{format}}',
    th: 'รูปแบบอินพุต {{format}}',
};
const clearTooltipLocales = {
    en: 'Clear',
    'zh-hant': '清除',
    'zh-cn': '清除',
    vi: 'Xoá sạch',
    th: 'ล้าง',
};
export const getDefaultPlaceholder = (lang) => placeholderLocales[lang] || placeholderLocales.en;
export const getDefaultPlaceholders = (lang) => placeholdersLocales[lang] || placeholdersLocales.en;
export const getDefaultInputTooltip = (lang) => inputTooltipLocales[lang] || inputTooltipLocales.en;
export const getDefaultClearTooltip = (lang) => clearTooltipLocales[lang] || clearTooltipLocales.en;
export { default as DatePicker } from './DatePicker';
export { default as DateRangePicker } from './DateRangePicker';
//# sourceMappingURL=index.js.map